'use client';

// used in home page
// used in category page
// used in categories page also

import { useLocale } from 'use-intl';
import NextImage from '../next-image';
import { usePathname } from '@/i18n/navigation';
import NextLink from '@/components/next-link';

const CategoryCard = ({
  info,
  isMobile,
  fromCategoryPage,
  fromCategoriesPage,
}) => {
  const locale = useLocale();
  const pathname = usePathname();
  return (
    <NextLink
      href={
        fromCategoryPage
          ? pathname.concat(`/${info?.url_key}`)
          : info?.url
            ? `/${info?.url}`
            : info?.url_key
              ? `/${info?.url_key}`
              : info?.['category-url']
                ? `/category/${info?.['category-url']}`
                : info?.currentURL || '#'
      }
      className={`flex flex-col items-center justify-center gap-2.5 rounded-lg bg-[#F6F6F7] p-2 pb-3`}
    >
      <NextImage
        alt={fromCategoryPage ? info?.name : info?.[`alt-${locale}`] || ''}
        className={`rounded-lg ${fromCategoryPage ? 'object-cover' : 'object-cover'} ${!fromCategoriesPage ? 'mx-auto max-h-[170px] min-h-[170px] max-w-[170px] min-w-[170px] max-lg:max-w-[145px] max-lg:min-w-[162px] max-md:max-h-[162px] max-md:min-h-[145px] max-sm:max-h-[110px] max-sm:min-h-[110px] max-sm:max-w-[110px] max-sm:min-w-[110px]' : 'max-h-[170px] min-h-[170px] max-sm:max-h-[150px] max-sm:min-h-[150px] max-sm:max-w-full max-sm:min-w-full'}`}
        src={
          fromCategoryPage
            ? process.env.NEXT_PUBLIC_IMG_BASEURL +
              info?.['category_mobile_image1']
            : isMobile
              ? info?.[`mobile-img-${locale}`]
              : info?.[`img-${locale}`]
        }
        width={170}
        height={170}
      />

      <p
        className={`line-clamp-1 text-center text-sm font-semibold capitalize max-sm:text-[11px]`}
        title={
          fromCategoryPage
            ? info?.name || info?.[`title-${locale}`]
            : info?.[`alt-${locale}`] || ''
        }
      >
        {fromCategoryPage
          ? info?.name || info?.[`title-${locale}`]
          : info?.[`alt-${locale}`] || ''}
      </p>
    </NextLink>
  );
};

export default CategoryCard;
